import React from "react";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";

import { ADD_PHOTOS } from "../../../constants/profiles";

import images from "../../../assets/img/images";

const ProfileCreated = (props) => {
  const { setStep, profile, close, classes, addAnotherProfile } = props;

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      style={{ height: "100%" }}
      wrap="nowrap"
    >
      <Grid item>
        <Grid container direction="row-reverse">
          <Grid item xs={2} className={classes.closeBtn}>
            <CloseIcon closeFunction={close} />
          </Grid>
          <Grid item xs={8} />
        </Grid>
      </Grid>
      <Grid item xs style={{ padding: "0px 48px 24px 48px" }}>
        <Grid container direction="column" alignItems="center">
          <Grid item className="text-54 text-center bold-500">
            {I18n.get("profiles_profileCreated")}
          </Grid>
          <Grid item style={{ margin: "24px 0px 38px 0px" }}>
            <img src={images.successIcon} alt="success" />
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={() => setStep(ADD_PHOTOS)}>
              {I18n.get("profiles_addPhotos")}
            </CustomButton>
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <Link
              to={"/profiles/" + profile.id}
              style={{ textDecoration: "none", fontSize: "inherit" }}
            >
              <CustomButton color="primary">
                {I18n.get("profiles_goToProfile")}
              </CustomButton>
            </Link>
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={addAnotherProfile}>
              {I18n.get("profiles_addAnotherProfile")}
            </CustomButton>
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={close}>
              {I18n.get("site_close")}
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

ProfileCreated.propTypes = {
  setStep: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  addAnotherProfile: PropTypes.func.isRequired,
};

export default ProfileCreated;
